// frontend/src/contexts/NotificationContext.js
import React, { createContext, useState, useEffect } from 'react';
import { io } from 'socket.io-client';

export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const [newNotification, setNewNotification] = useState(false);

  useEffect(() => {
    // Connect to the backend Socket.io server
    const socket = io(`${process.env.REACT_APP_API_URL}`);

    socket.on('notification', (notif) => {
      console.log('Notification received:', notif);
      // Ensure notif.date is a valid timestamp (if not, assign Date.now())
      if (!notif.date) {
        notif.date = new Date();
      }
      setNotifications((prev) => [notif, ...prev]);
      setNewNotification(true);
    });

    return () => socket.disconnect();
  }, []);

  // Periodically clear notifications older than one week
  useEffect(() => {
    const intervalId = setInterval(() => {
      const oneWeekAgo = Date.now() - 604800000; // 7 days in milliseconds
      setNotifications((prevNotifications) =>
        prevNotifications.filter((notif) => new Date(notif.date).getTime() >= oneWeekAgo)
      );
      // If there are no notifications newer than one week, clear the newNotification flag.
      setNewNotification((prev) => {
        const hasRecent = notifications.some(
          (notif) => new Date(notif.date).getTime() >= oneWeekAgo
        );
        return hasRecent;
      });
    }, 60000); // Check every minute

    return () => clearInterval(intervalId);
  }, [notifications]);

  return (
    <NotificationContext.Provider value={{ notifications, newNotification }}>
      {children}
    </NotificationContext.Provider>
  );
};
